import React from 'react';
import { Button, Avatar, makeStyles, darken } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { IButtonSendTemplate } from './types';
import { WHATSAPP_COLOR } from 'src/constants/variants/variants';

const useStyles = makeStyles(() => ({
    button: {
        backgroundColor: WHATSAPP_COLOR,
        height: 60,
        '&:hover': { backgroundColor: darken(WHATSAPP_COLOR, 0.2) },
    },
}));

export const ButtonSendTemplate = ({
    currentTemplate,
    submit,
    onClose,
    ...props
}: IButtonSendTemplate) => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const classes = useStyles();

    const handleSubmit = () => {
        if (currentTemplate._id !== '' && currentTemplate._id !== undefined) {
            submit(currentTemplate);
            onClose();
        } else {
            enqueueSnackbar(t('TwilioTemplates.Choose'), {
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                },
                variant: 'error',
            });
        }
    };

    return (
        <Button
            variant="contained"
            size="large"
            fullWidth
            color="primary"
            startIcon={
                <Avatar alt="wsp-icon" src={'/static/logos/whatsapp.png'} />
            }
            onClick={handleSubmit}
            className={classes.button}
            data-testid="button-send-template"
            {...props}
        >
            {t('Leads.SendWsp')}
        </Button>
    );
};
